import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TimeAgoExtendsPipe } from './pipes/time-ago.pipe';
import { SuccessNotificationComponent } from './components/success-notification/success-notification.component';
import { ErrorNotificationComponent } from './components/error-notification/error-notification.component';
import { AutoFocusDirective } from './directives/auto-focus/auto-focus.directive';
import { PoprModule } from './components/popr/popr.module';
import { TwoFactorComponent } from './components/two-factor/two-factor.component';
import { PendingEditsModule } from './components/pending-edits/pending-edits.module';
import { SpinnerDefaultComponent } from './components/spinners/spinner-default/spinner-default.component';
import { SecretInputComponent } from './components/input/secret-input/secret-input.component';
import { InputErrorComponent } from './components/input/input-error/input-error.component';
import { PrimaryButtonComponent } from './components/buttons/spinner-buttons/primary-button/primary-button.component';
import { ToggleButtonComponent } from './components/buttons/spinner-buttons/toggle-button/toggle-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerSmallComponent } from './components/spinners/spinner-small/spinner-small.component';
import { TextButtonComponent } from './components/buttons/spinner-buttons/text-button/text-button.component';
import {
  SecondaryOutlineButtonComponent
 } from './components/buttons/spinner-buttons/secondary-outline-button/secondary-outline-button.component';
import { TrapFocusDirective } from './directives/trap-focus/trap-focus.directive';
import { DirectivesModule } from './directives/directives.module';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { AddNewNumberComponent } from './components/add-new-number/add-new-number.component';
import {
  CheckMarkCircleIcon,
  ChevronIcon,
  CrossIcon,
  ExclamationTriangleIcon,
  IconModule,
  IconRegistry,
  UtilityCrossFatIcon,
  EmailModule, PasswordModule, PhoneModule, CommunicationDevicesMailIcon, CommunicationDevicesMobileIcon, CommunicationDevicesPhone
} from '@ciam/library';
import { VerifyIdentityComponent } from './components/verify-identity/verify-identity.component';
import { VerificationMethodComponent } from './components/verify-identity/verification-method/verification-method.component';
import { ChannelsListItemComponent } from './components/verify-identity/channels-list-item/channels-list-item.component';
import { EnterPinComponent } from './components/verify-identity/enter-pin/enter-pin.component';
import { MaskValuePipe } from './pipes/mask-value.pipe';
import { ExternalLinkDirective } from './directives/external-link/external-link.directive';

@NgModule({
  declarations: [
    ErrorNotificationComponent,
    InputErrorComponent,
    PrimaryButtonComponent,
    SecondaryOutlineButtonComponent,
    SecretInputComponent,
    SpinnerDefaultComponent,
    SpinnerSmallComponent,
    SuccessNotificationComponent,
    TextButtonComponent,
    TimeAgoExtendsPipe,
    MaskValuePipe,
    ToggleButtonComponent,
    TwoFactorComponent,
    FormSelectComponent,
    AddNewNumberComponent,
    VerifyIdentityComponent,
    VerificationMethodComponent,
    EnterPinComponent,
    ChannelsListItemComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        PendingEditsModule,
        PoprModule,
        TranslateModule,
        DirectivesModule,
        PasswordModule,
        EmailModule,
        PhoneModule,
        ReactiveFormsModule,
        IconModule
    ],
    exports: [
      ErrorNotificationComponent,
      PendingEditsModule,
      PoprModule,
      PrimaryButtonComponent,
      SecondaryOutlineButtonComponent,
      SecretInputComponent,
      SpinnerDefaultComponent,
      SpinnerSmallComponent,
      SuccessNotificationComponent,
      TextButtonComponent,
      TimeAgoExtendsPipe,
      ToggleButtonComponent,
      TranslateModule,
      TwoFactorComponent,
      InputErrorComponent,
      AutoFocusDirective,
      TrapFocusDirective,
      EmailModule,
      PasswordModule,
      PhoneModule,
      FormSelectComponent,
      AddNewNumberComponent,
      DirectivesModule

    ]
 })
export class SharedModule {
  constructor(private iconRegistry: IconRegistry) {
    this.iconRegistry.register(
      UtilityCrossFatIcon,
      CrossIcon,
      ExclamationTriangleIcon,
      ChevronIcon,
      CheckMarkCircleIcon,
      CommunicationDevicesMailIcon,
      CommunicationDevicesMobileIcon,
      CommunicationDevicesPhone
    );
  }
}
